"use strict";

require("core-js/modules/es.array.iterator");

var curry = require("./curry.js");

const bindMethod = curry((name, obj, ...args) => obj[name].bind(obj, ...args));
module.exports = bindMethod;